const GET_STANDINGS_SUCCESS = 'standings/GET_STANDINGS_SUCCESS'
const GET_STANDINGS_LOADING = 'standings/GET_STANDINGS_LOADING'
const GET_STANDINGS_ERROR = 'standings/GET_STANDINGS_ERROR'

const GET_STANDINGS_CLINCH_STATUS_SUCCESS = 'standings/GET_STANDINGS_CLINCH_STATUS_SUCCESS'
const GET_STANDINGS_CLINCH_STATUS_LOADING = 'standings/GET_STANDINGS_CLINCH_STATUS_LOADING'
const GET_STANDINGS_CLINCH_STATUS_ERROR = 'standings/GET_STANDINGS_CLINCH_STATUS_ERROR'

const GET_STANDINGS_INFORMATION_SUCCESS = 'standings/GET_STANDINGS_INFORMATION_SUCCESS'
const GET_STANDINGS_INFORMATION_LOADING = 'standings/GET_STANDINGS_INFORMATION_LOADING'
const GET_STANDINGS_INFORMATION_ERROR = 'standings/GET_STANDINGS_INFORMATION_ERROR'

export {
  GET_STANDINGS_SUCCESS,
  GET_STANDINGS_LOADING,
  GET_STANDINGS_ERROR,
  GET_STANDINGS_CLINCH_STATUS_SUCCESS,
  GET_STANDINGS_CLINCH_STATUS_LOADING,
  GET_STANDINGS_CLINCH_STATUS_ERROR,
  GET_STANDINGS_INFORMATION_SUCCESS,
  GET_STANDINGS_INFORMATION_LOADING,
  GET_STANDINGS_INFORMATION_ERROR,
}
